import React, { useState, useContext, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Popover,
  Button,
  styled,
  tableCellClasses,
  Badge,
} from "@mui/material";
import AppContext from "../context/context";
import { isMobile } from "../../globalStyles/mobile";
import Pagination from "../pagination";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import FilterModal from "../filterModal";
import { useTheme } from "@mui/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import OverpackViewModal from "../overpack-view-modal";
import EditIcon from "../../globalStyles/icons/editIcon";
import TableHeader from "../table-header";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    //border: "1px solid #EAECF0",
    padding: "6px",
    border: "none",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const OverpackList = ({
  data,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  onChangeFilter,
  filterData,
  onEditData,
  selectedOverpack,
  setSelectedOverpack,
}) => {
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const { user } = useContext(AppContext);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    loadMoreButton: false,
    options: [],
    searchKey: "",
  });
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const clientId = localStorage.getItem("client_id");
  const openPopover = Boolean(anchorElPopover);
  const startIndex = page * rowsPerPage;
  // const [selectedOverpack, setSelectedOverpack] = useState(null);
  const [overpackData, setOverpackData] = useState([]);

  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setOpenFilterModal(true);
    setSelectedFilterData(filterData.columns.find((x) => x.key == filterKey));
  };

  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const handleViewClick = (item) => {
    setOpenViewModal(true);
    handlePopoverClose();
  };
  const handleEditClick = (item) => {
    onEditData && onEditData();
    handlePopoverClose();
  };
  const handlePopoverOpen = (event, item) => {
    console.log(item);
    setSelectedOverpack(item);
    event.stopPropagation();
    setAnchorElPopover(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElPopover(null);
  };
  useEffect(() => {
    setOverpackData(
      data?.map((item) => ({
        ...item,
        action: (
          <Box sx={{ display: "flex", boxShadow: "none" }}>
            <IconButton
              aria-label="more actions"
              onClick={(e) => handlePopoverOpen(e, item)}
              sx={{
                color: openPopover ? "primary" : "inherit",
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Popover
              open={Boolean(anchorElPopover)}
              anchorEl={anchorElPopover}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: isMobile() ? "bottom" : "top",
                horizontal: isMobile() ? "center" : "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  boxShadow: "none",
                  border: "1px solid var(--border-color)",
                  borderRadius: "4px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  boxShadow: "none",
                  gap: 2,
                }}
              >
                <Button
                  style={{
                    color: "var(--text-tertiary)",
                    justifyContent: "flex-start",
                    textTransform: "none",
                  }}
                  onClick={() => handleViewClick(item)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <ViewIcon />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={"var(--text-tertiary)"}
                      fontWeight={500}
                    >
                      View
                    </Typography>
                  </Box>
                </Button>

                <Button
                  style={{
                    color: "var(--text-tertiary)",
                    justifyContent: "flex-start",
                    textTransform: "none",
                    cursor: selectedOverpack?.overpack?.manifest_id
                      ? "not-allowed"
                      : "pointer",
                  }}
                  onClick={() => {
                    if (!selectedOverpack?.overpack?.manifest_id) {
                      handleEditClick(item);
                    }
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    width="100%"
                    gap={1}
                  >
                    <EditIcon
                      fill={
                        selectedOverpack?.overpack?.manifest_id
                          ? "grey"
                          : primary_color
                      }
                    />
                    <Typography
                      fontFamily={"poppins"}
                      fontSize={"16px"}
                      color={
                        selectedOverpack?.overpack?.manifest_id
                          ? "grey"
                          : primary_color
                      }
                      fontWeight={500}
                    >
                      Edit
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </Popover>
          </Box>
        ),
      })),
    );
  }, [data, anchorElPopover]);

  const NoDataImage = () => (
    <div
      style={{
        width: "100%",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <img
        src="no_data_rateCard.png"
        alt="No data available"
        style={{ objectFit: "fill", minHeight: "100%" }}
      />
    </div>
  );

  const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split(".").reduce((acc, key) => acc?.[key], obj);
  };

  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "overpack.id",
      title: "OVERPACK",
      filterKey: "overpack_id",
      handleOpenFilter: handleOpenFilter,
      displayKey: "overpack.id",
    },
    {
      key: "overpack.entry_point",
      title: "ENTRY POINT",
      filterKey: "overpack.entry_point",
      handleOpenFilter: handleOpenFilter,
      displayKey: "overpack.entry_point",
    },
    {
      key: "overpack.exit_point",
      title: "EXIT POINT",
      filterKey: "overpack.exit_point",
      handleOpenFilter: handleOpenFilter,
      displayKey: "overpack.exit_point",
    },
    {
      key: "overpack.carrier",
      title: "CARRIER",
      filterKey: "overpack.carrier",
      handleOpenFilter: handleOpenFilter,
      displayKey: "overpack.carrier",
    },
    {
      key: "overpack.shipments.length",
      title: "NO OF SHIPMENTS",
      displayKey: "overpack.shipments.length",
    },
    {
      key: "overpack",
      title: "DIMENSION",

      render: (x) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {`${x?.overpack.length} * ${x?.overpack.width} * ${x?.overpack.height}` ||
            "--"}
        </Typography>
      ),
    },

    { key: "action", title: "", width: "3%", displayKey: "action" },
  ];

  const MobileCardView = ({ data }) => {
    return (
      <Box sx={{ width: "100%", padding: 0.5 }}>
        {data.length === 0 ? (
          <NoDataImage />
        ) : (
          data?.map((x, index) => (
            <Card
              key={index}
              sx={{
                marginBottom: 2,
                backgroundColor: "#ffff",
                borderRadius: 4,
              }}
            >
              <CardContent>
                <div style={{ width: "100%" }}>
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Grid container spacing={2} sx={{ marginTop: 1 }}>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Leg
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.leg}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Code
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.code}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="poppins"
                          color="var(--text-tertiary)"
                          fontWeight={600}
                          textAlign="left"
                        >
                          Description
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          fontSize={14}
                          fontFamily="Poppins"
                          color="#606060"
                          fontWeight={500}
                          noWrap
                          overflow="hidden"
                          textOverflow="ellipsis"
                          textAlign="left"
                        >
                          : {x?.description}
                        </Typography>
                      </Grid>
                      {user.role == "admin" ? (
                        <Grid item xs={6}>
                          <Typography
                            fontSize={14}
                            fontFamily="poppins"
                            color="var(--text-tertiary)"
                            fontWeight={600}
                            textAlign="left"
                          >
                            Optional
                          </Typography>
                        </Grid>
                      ) : null}
                      {user.role == "admin" ? (
                        <Grid item xs={6}>
                          <Typography
                            fontSize={14}
                            fontFamily="Poppins"
                            color="#606060"
                            fontWeight={500}
                            noWrap
                            overflow="hidden"
                            textOverflow="ellipsis"
                            textAlign="left"
                          >
                            : {x?.optional == true ? "Yes" : "No"}
                          </Typography>
                        </Grid>
                      ) : (
                        <> </>
                      )}
                      {user.role == "admin" ? (
                        <Grid item xs={6}>
                          <Typography
                            fontSize={14}
                            fontFamily="poppins"
                            color="var(--text-tertiary)"
                            fontWeight={600}
                            textAlign="left"
                          >
                            Sysytem Generated
                          </Typography>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {user.role == "admin" ? (
                        <Grid item xs={6}>
                          <Typography
                            fontSize={14}
                            fontFamily="Poppins"
                            color="#606060"
                            fontWeight={500}
                            noWrap
                            overflow="hidden"
                            textOverflow="ellipsis"
                            textAlign="left"
                          >
                            : {x?.system_generated == true ? "Yes" : "No"}
                          </Typography>
                        </Grid>
                      ) : (
                        <></>
                      )}
                    </Grid>
                  </Box>

                  <Box mt={2} justifyContent={"flex-end"} display="flex">
                    {x?.action}
                  </Box>
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </Box>
    );
  };

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        // paddingBottom: 20,
        // marginTop: 5,
      }}
    >
      {isMobile() ? (
        <MobileCardView data={data} />
      ) : (
        <TableContainer
          sx={{
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                {TableSchema.map((column) => (
                  <TableHeader
                    key={column.key}
                    column={column}
                    filterKey={column.filterKey}
                    handleOpenFilter={column.handleOpenFilter}
                    title={column.title}
                  />
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {overpackData.length === 0 ? (
                <StyledTableRow>
                  <TableCell colSpan={8} align="center">
                    <NoDataImage />
                  </TableCell>
                </StyledTableRow>
              ) : (
                overpackData?.map((x, rowIndex) => (
                  <StyledTableRow key={rowIndex}>
                    {TableSchema.map((column, colIndex) => (
                      <StyledTableCell
                        key={column.key || colIndex}
                        sx={{ width: column.width }}
                      >
                        {column.displayKey ? (
                          <Typography
                            fontSize="12px"
                            color="var(--text-secondary)"
                            fontWeight={400}
                            fontFamily={"Poppins"}
                          >
                            {getNestedValue(x, column.displayKey) || "--"}
                          </Typography>
                        ) : column.render ? (
                          column.render(x, rowIndex)
                        ) : (
                          "--"
                        )}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
  return (
    <>
      <div sx={{ minWidth: "100%" }}>
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile() ? "60vh" : `calc(100vh - 210px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {renderListView()}
        </div>

        <Pagination
          dataCount={dataCount}
          rowsPerPage={rowsPerPage}
          page={page}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          disableNext={dataCount <= (page + 1) * filterData.limit}
        />
        <OverpackViewModal
          data={selectedOverpack}
          open={openViewModal}
          onClose={() => {
            setOpenViewModal(false);
            setSelectedOverpack(null);
          }}
          primary_color={primary_color}
        />
        <Popover
          open={Boolean(anchorElFilter)}
          anchorEl={anchorElFilter}
          onClose={handleCloseFilter}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          disableScrollLock={true}
        >
          <FilterModal
            open={openFilterModal}
            onClose={handleCloseFilter}
            options={selectedfilterData?.options}
            selectedValues={selectedfilterData?.filter}
            onSave={handleSaveFilter}
            currentSortOrder={selectedfilterData?.sort}
            filterKey={selectedfilterData?.key}
            hasMore={selectedfilterData?.loadMoreButton}
            displayKey={selectedfilterData?.displayKey}
            id={selectedfilterData?.id}
            fetchApi={selectedfilterData?.fetchApi}
            searchKey={selectedfilterData?.searchKey}
          />
        </Popover>
      </div>
    </>
  );
};

export default OverpackList;
